/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const InitialPortfolioRebalanceStart = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'successBlue'} />
      <Title>{t('INITIAL_PORTFOLIO_REBALANCE_START_MODAL__title')}</Title>
      <Text>{t('INITIAL_PORTFOLIO_REBALANCE_START_MODAL__desc')}</Text>
    </>
  );
};

export { InitialPortfolioRebalanceStart };
